function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M10 0C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10S15.523 0 10 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M14.4 13.505l-3.282-3.287 3.263-3.241a.62.62 0 000-.882.633.633 0 00-.89 0L10.233 9.33 6.926 6.02a.626.626 0 00-.89 0 .634.634 0 000 .893l3.302 3.308-3.32 3.298a.62.62 0 000 .882.633.633 0 00.89 0l3.316-3.294 3.286 3.292a.626.626 0 00.89 0 .634.634 0 000-.893z"
}));
function SvgCloseHover(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _ref);
}
export default SvgCloseHover;